export default __webpack_public_path__ + "static/En_EFTB_iMedical_Cont-e2b1442ef1dc9a06481dca8dbd846c1e.pdf";